/*
 * PAWS & PEARLS · THE MUSE · RETURN FIREFLIES V1.3 · LIVING HOMECOMING
 * 30 October 2026
 * Additive Secret Sky behaviour for duplicate theme work.
 *
 * Purpose:
 * - Keep the existing enchanted-night fireflies in the night sky untouched.
 * - Create NEW extra fireflies only for the RETURN journey.
 * - Let them gather around the descending balloon and settle into the stage.
 * - After landing, animate clear, graceful flight paths while keeping each illustration and its brightness steady.
 *
 * Assumptions:
 * - The stage id remains #pp-muse-balloon-stage.
 * - The balloon flight remains the approved 39,000ms WAAPI flight.
 * - Existing night/firefly scripts remain installed.
 */
(function(){
  'use strict';

  var STAGE_ID = 'pp-muse-balloon-stage';
  var ASSET_ID = 'pp-muse-enchanted-night-assets-v1';
  var STYLE_ID = 'pp-muse-return-fireflies-style-v1';
  var DEPLOY_FLAG = 'ppReturnFirefliesV1';
  var FLIGHT_MS = 39000;
  var DESCENT_START_MS = 24000; // approved ascent 16s + summit pause 8s
  var DEPLOY_AT_MS = 25500;     // a little into the return, so they feel like an escort home
  var FRAME_MS = 135; // fewer image swaps for smoother mobile performance
  var CLASS = 'pp-muse-return-firefly-v1';
  var ESCORT_CLASS = 'pp-muse-return-firefly-escort-v1';
  var SETTLED_CLASS = 'pp-muse-return-firefly-settled-v1';
  var COUNT = 10; // ten independent new return swarms; originals in night remain untouched
  var SPECS = [
    { ringX:-0.68, ringY:-0.38, driftX: 10, driftY:  8, size:.20, phase:0.3, twirl: 8 },
    { ringX: 0.59, ringY:-0.18, driftX:  9, driftY:  7, size:.19, phase:1.2, twirl:-7 },
    { ringX:-0.61, ringY: 0.21, driftX:  8, driftY: 10, size:.21, phase:2.1, twirl: 6 },
    { ringX: 0.73, ringY: 0.29, driftX: 10, driftY:  9, size:.20, phase:3.0, twirl:-9 },
    { ringX:-0.14, ringY:-0.69, driftX:  9, driftY:  9, size:.18, phase:3.8, twirl: 5 },
    { ringX: 0.19, ringY: 0.66, driftX: 10, driftY:  8, size:.20, phase:4.7, twirl:-6 },
    { ringX:-0.86, ringY:-0.04, driftX:  8, driftY:  7, size:.18, phase:5.4, twirl: 8 },
    { ringX: 0.91, ringY:-0.47, driftX: 10, driftY:  8, size:.17, phase:6.3, twirl:-6 },
    { ringX:-0.83, ringY: 0.59, driftX:  8, driftY: 11, size:.18, phase:7.2, twirl: 7 },
    { ringX: 0.81, ringY: 0.67, driftX: 11, driftY:  9, size:.19, phase:8.1, twirl:-8 }
  ];
  // Spread the arrival around the place occupied by the departing butterflies.
  // Each image is a whole existing firefly SWARM, not a single point of light.
  var SETTLE_SLOTS = [
    { x:.15, y:.32, orbitX:10, orbitY: 9, scale:1.02, phase:.4 },
    { x:.27, y:.65, orbitX: 9, orbitY:11, scale:1.08, phase:1.2 },
    { x:.43, y:.78, orbitX:11, orbitY: 9, scale:.96, phase:2.0 },
    { x:.73, y:.28, orbitX:10, orbitY: 8, scale:1.06, phase:2.9 },
    { x:.84, y:.63, orbitX: 9, orbitY:10, scale:1.04, phase:3.8 },
    { x:.58, y:.85, orbitX:11, orbitY:10, scale:1.00, phase:4.6 },
    { x:.12, y:.78, orbitX: 8, orbitY:10, scale:.90, phase:5.4 },
    { x:.91, y:.84, orbitX: 9, orbitY: 7, scale:.92, phase:6.2 },
    { x:.37, y:.33, orbitX: 9, orbitY: 9, scale:.94, phase:7.0 },
    { x:.64, y:.48, orbitX:10, orbitY: 8, scale:.98, phase:7.8 }
  ];

  function clamp(v,min,max){ return Math.min(max, Math.max(min, v)); }
  function ease(v){ v=clamp(v,0,1); return v*v*(3-2*v); }
  function ready(){
    return document.documentElement.classList.contains('pp-muse-secret-sky-page') &&
      !!document.getElementById('pp-muse-secret-sky');
  }
  function installStyle(){
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '#'+STAGE_ID+' .pp-muse-return-firefly-bed-v1{position:absolute!important;inset:0!important;pointer-events:none!important;overflow:hidden!important;z-index:5!important;contain:paint!important;}',
      '.'+CLASS+'{position:absolute;left:0;top:0;display:block;width:var(--pp-rff-size);height:auto;max-width:none!important;pointer-events:none!important;user-select:none!important;-webkit-user-drag:none!important;transform-origin:center center;filter:brightness(1.55) contrast(1.13) saturate(1.07) drop-shadow(0 0 6px rgba(255,224,141,.48));will-change:transform,opacity;}',
      '.'+CLASS+'.'+ESCORT_CLASS+'{position:fixed!important;left:0!important;top:0!important;z-index:2147482997!important;}',
      // Static, soft-lit artwork. Do not use screen blend or brightness animation at home.
      '.'+CLASS+'.'+SETTLED_CLASS+'{mix-blend-mode:normal;filter:brightness(1.42) contrast(1.08) saturate(1.03) drop-shadow(0 0 4px rgba(255,224,141,.28));}',
      '@media (prefers-reduced-motion: reduce){.'+CLASS+'{will-change:auto;}}'
    ].join('\n');
    document.head.appendChild(s);
  }
  function assetUrls(){
    var holder = document.getElementById(ASSET_ID);
    if (!holder) return [];
    var urls = [];
    for (var i=1;i<=15;i++) {
      var key = 'swarm' + String(i).padStart(2,'0');
      var value = holder.dataset[key];
      if (typeof value === 'string' && value) urls.push(value);
    }
    return urls;
  }
  function findFlight(button){
    if (!button || typeof button.getAnimations !== 'function') return null;
    try {
      return button.getAnimations().find(function(a){
        return a.effect && a.effect.getTiming &&
          Math.abs(Number(a.effect.getTiming().duration) - FLIGHT_MS) < 1 &&
          a.playState !== 'finished' && a.playState !== 'idle';
      }) || null;
    } catch(e){ return null; }
  }
  function boot(){
    if (!ready()) return;
    var stage = document.getElementById(STAGE_ID);
    if (!stage || stage.dataset[DEPLOY_FLAG] === '1') return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var urls = assetUrls();
    if (!stage || urls.length < 3) {
      console.warn('[P&P Return Fireflies] Missing enchanted-night swarm assets.');
      return;
    }
    stage.dataset[DEPLOY_FLAG] = '1';
    installStyle();

    var bed = document.createElement('div');
    bed.className = 'pp-muse-return-firefly-bed-v1';
    bed.setAttribute('aria-hidden','true');
    stage.appendChild(bed);

    var bugs = [];
    var raf = 0;
    var mode = 'waiting'; // waiting -> escort -> settled
    var started = false;
    var settledAt = 0;
    var balloon = null;
    var flight = null;
    var unloaded = false;
    var lastSettledPaint = 0;

    function makeBug(i){
      var img = document.createElement('img');
      img.className = CLASS;
      img.alt = '';
      img.setAttribute('aria-hidden','true');
      img.decoding = 'async';
      img.draggable = false;
      img.src = urls[i % urls.length];
      img.style.opacity = '0';
      img.style.setProperty('--pp-rff-size','40px');
      bed.appendChild(img);
      return {
        el: img,
        spec: SPECS[i % SPECS.length],
        slot: SETTLE_SLOTS[i % SETTLE_SLOTS.length],
        frame: -1,
        escortProgress: 0,
        settleProgress: 0,
        settlePoint: null,
        lastEscort: null
      };
    }
    for (var i=0;i<COUNT;i++) bugs.push(makeBug(i));

    function paintFrame(bug, now, offset){
      var frame = Math.floor((now + offset) / FRAME_MS) % urls.length;
      if (frame === bug.frame) return;
      bug.frame = frame;
      bug.el.src = urls[frame];
    }

    function launchEscort(){
      if (started) return;
      if (!balloon || !balloon.classList.contains('pp-muse-flight-overlay')) return;
      flight = findFlight(balloon);
      if (!flight) return;
      started = true;
      mode = 'escort';
      bugs.forEach(function(bug){
        bug.el.classList.add(ESCORT_CLASS);
        document.body.appendChild(bug.el);
      });
      if (bed.isConnected) bed.remove();
    }

    function settle(){
      if (mode === 'settled') return;
      mode = 'settled';
      settledAt = performance.now();
      if (!bed.isConnected && stage.isConnected) stage.appendChild(bed);
      bugs.forEach(function(bug, i){
        var rect = bug.el.getBoundingClientRect();
        var stageRect = stage.getBoundingClientRect();
        bug.lastEscort = { x: rect.left - stageRect.left, y: rect.top - stageRect.top };
        bug.el.classList.remove(ESCORT_CLASS);
        bug.el.classList.add(SETTLED_CLASS);
        bed.appendChild(bug.el);
        // These are 15 different swarm ILLUSTRATIONS, not sequential movement frames.
        // Swapping between them at 135ms made the landing flash and appear chaotic.
        // Lock each landed swarm to one distinct approved illustration instead.
        var restingFrame = (i * 3 + 1) % urls.length;
        bug.el.src = urls[restingFrame];
        bug.frame = restingFrame;
        bug.el.style.opacity = '0.86';
        bug.settleProgress = 0;
        var slot = bug.slot;
        var size = clamp(stageRect.width * (0.19 * slot.scale), 130, 245);
        bug.el.style.setProperty('--pp-rff-size', size.toFixed(1)+'px');
        bug.settlePoint = {
          x: stageRect.width * slot.x - size * 0.5,
          y: stageRect.height * slot.y - size * 0.5,
          size: size
        };
      });
    }

    function cleanup(){
      unloaded = true;
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
      document.removeEventListener('click', handleClick, false);
      document.removeEventListener('shopify:section:load', boot);
      document.removeEventListener('shopify:section:unload', handleUnload);
      bugs.forEach(function(b){ if (b.el && b.el.isConnected) b.el.remove(); });
      if (bed && bed.isConnected) bed.remove();
    }

    function handleUnload(ev){
      if (ev.target && ev.target.contains(stage)) cleanup();
    }

    function handleClick(ev){
      var hit = ev.target && ev.target.closest && ev.target.closest('#'+STAGE_ID+' .pp-balloon, .pp-muse-flight-overlay.pp-balloon');
      if (!hit || unloaded) return;
      balloon = hit;
    }

    function updateWaiting(now){
      // Invisible until the return portion. Nothing decorative beforehand.
      if (!balloon || !balloon.isConnected || !balloon.classList.contains('pp-muse-flight-overlay')) return;
      if (!flight) flight = findFlight(balloon);
      var ms = flight ? Number(flight.currentTime) : 0;
      if (isFinite(ms) && ms >= DEPLOY_AT_MS) launchEscort();
      if (reduced && started) settle();
    }

    function updateEscort(now){
      if (!balloon || !balloon.isConnected) { settle(); return; }
      var ms = flight ? Number(flight.currentTime) : 0;
      if (!isFinite(ms)) ms = DESCENT_START_MS;
      var rect = balloon.getBoundingClientRect();
      var cx = rect.left + rect.width * 0.5;
      var cy = rect.top + rect.height * 0.44;
      var phaseT = now / 1000;
      var descendFrac = clamp((ms - DESCENT_START_MS) / (FLIGHT_MS - DESCENT_START_MS), 0, 1);
      bugs.forEach(function(bug, i){
        var s = bug.spec;
        var size = clamp(rect.width * s.size, 78, 118);
        bug.el.style.setProperty('--pp-rff-size', size.toFixed(1)+'px');
        var ringRadiusX = rect.width * 0.78;
        var ringRadiusY = rect.height * 0.72;
        var targetX = cx + s.ringX * ringRadiusX - size * 0.5 + Math.sin(phaseT * 1.3 + s.phase) * s.driftX;
        var targetY = cy + s.ringY * ringRadiusY - size * 0.5 + Math.cos(phaseT * 1.1 + s.phase) * s.driftY;
        var trailLift = (1 - descendFrac) * 18;
        targetY -= trailLift;
        bug.lastEscort = { x: targetX, y: targetY };
        var opacity = 0.93 + Math.sin(phaseT * 1.9 + s.phase) * 0.07;
        bug.el.style.opacity = String(clamp(opacity, 0.78, 1));
        bug.el.style.transform = 'translate3d(' + targetX.toFixed(1) + 'px,' + targetY.toFixed(1) + 'px,0) rotate(' + (Math.sin(phaseT * 1.4 + s.phase) * s.twirl).toFixed(1) + 'deg) scale(' + (0.96 + Math.sin(phaseT*1.7+s.phase) * 0.03).toFixed(3) + ')';
        paintFrame(bug, now, i * 110);
      });
      if ((flight && flight.playState === 'finished') || ms >= FLIGHT_MS - 10 || rect.top > window.innerHeight + 120) {
        settle();
      }
    }

    function updateSettled(now){
      if (!stage.isConnected) { cleanup(); return; }
      var stageRect = stage.getBoundingClientRect();
      var t = now / 1000;
      bugs.forEach(function(bug, i){
        var slot = bug.slot;
        var point = bug.settlePoint;
        if (!point) return;
        var start = bug.lastEscort || point;
        var settleFrac = bug.settleProgress = clamp((now - settledAt) / (1450 + i*60), 0, 1);
        var eased = ease(settleFrac);
        var baseX = start.x + (point.x - start.x) * eased;
        var baseY = start.y + (point.y - start.y) * eased;
        // LIVING HOMECOMING: distinctly visible flight paths, not a light show.
        // Each settled image remains FIXED: zero image swapping, zero opacity
        // pulsing, zero CSS brightness changes. Only its POSITION and a very
        // small tilt/scale change smoothly to create independent movement.
        // Two slow, incommensurate curves give each group a wandering path,
        // rather than synchronised bouncing. Typical range: about 20–35 px
        // sideways and 15–25 px vertically (depending on its assigned slot).
        var motionIn = reduced ? 0 : ease((now - settledAt) / 1800);
        var bobX = motionIn * (
          Math.sin(t * (0.77 + (i % 3) * 0.055) + slot.phase) * slot.orbitX * 2.15 +
          Math.sin(t * (0.22 + (i % 4) * 0.021) + slot.phase * 1.31) * slot.orbitX * 1.0
        );
        var bobY = motionIn * (
          Math.cos(t * (0.64 + (i % 4) * 0.046) + slot.phase) * slot.orbitY * 1.65 +
          Math.sin(t * (0.30 + (i % 3) * 0.037) + slot.phase * 1.24) * slot.orbitY * 0.70
        );
        var tilt = motionIn * Math.sin(t * 0.63 + slot.phase) * 2.0;
        var scale = 1 + motionIn * Math.sin(t * 0.49 + slot.phase) * 0.012;
        bug.el.style.opacity = '0.86'; // continuous, steady light; no flashing
        bug.el.style.transform = 'translate3d(' +
          (baseX + bobX).toFixed(1) + 'px,' +
          (baseY + bobY).toFixed(1) + 'px,0) rotate(' +
          tilt.toFixed(1) + 'deg) scale(' + scale.toFixed(3) + ')';
      });
    }

    function tick(now){
      raf = 0;
      if (unloaded || !stage.isConnected) { cleanup(); return; }
      if (document.hidden) { raf = requestAnimationFrame(tick); return; }
      if (mode === 'waiting') updateWaiting(now);
      else if (mode === 'escort') updateEscort(now);
      else if (mode === 'settled' && now - lastSettledPaint >= 33) {
        lastSettledPaint = now;
        updateSettled(now);
      }
      raf = requestAnimationFrame(tick);
    }

    document.addEventListener('click', handleClick, false);
    document.addEventListener('shopify:section:unload', handleUnload);
    raf = requestAnimationFrame(tick);

    window.ppMuseReturnFirefliesV1 = {
      version: '1.3-living-homecoming',
      getStatus: function(){
        return {
          mode: mode,
          started: started,
          flightTimeMs: flight ? Math.round(Number(flight.currentTime) || 0) : null,
          count: bugs.length,
          settled: mode === 'settled'
        };
      }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
